export default __webpack_public_path__ + "static/media/element_12.8cb0e40c.webp";